export function formatarNCotacao(numero) {
    return numero.toString().replace(/^(\d{4})(\d{6})$/, "$1.$2");
}